import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import AppWithManualUserId from "./AppWithManualUserId";
import AppContainer from "./AppContainer";

ReactDOM.render(
    <AppContainer>
        <AppWithManualUserId/>
    </AppContainer>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
